// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mini-container {
    width: 380px;
    height: 650px;
    background-color: rgba(255, 255, 255, 1);
}

.profile-mini {
    position: relative;
}

.left-design {
    position: absolute;
     top:-60px;
    left: -5px;
   
}

.right-design{
    position: absolute;
    right: -5px;
    top: -60px;
   
  
}
.card-mini{
    position:relative;
}

.bottom-design{
    position: absolute;
    right:0px;
    bottom: -530px;
}

.user-face{
    position:absolute;
    top:17px;
}

.gradient-text {
   color:  rgba(247, 100, 80, 1)
}
.gradient-text2 {
   color: rgba(32, 165, 99, 1) 
}

`, "",{"version":3,"sources":["webpack://./src/styles/MiniProfile.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAa;IACb,wCAAwC;AAC5C;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;KACjB,SAAS;IACV,UAAU;;AAEd;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;;;AAGd;AACA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,QAAQ;AACZ;;AAEA;GACG;AACH;AACA;GACG;AACH","sourcesContent":[".mini-container {\n    width: 380px;\n    height: 650px;\n    background-color: rgba(255, 255, 255, 1);\n}\n\n.profile-mini {\n    position: relative;\n}\n\n.left-design {\n    position: absolute;\n     top:-60px;\n    left: -5px;\n   \n}\n\n.right-design{\n    position: absolute;\n    right: -5px;\n    top: -60px;\n   \n  \n}\n.card-mini{\n    position:relative;\n}\n\n.bottom-design{\n    position: absolute;\n    right:0px;\n    bottom: -530px;\n}\n\n.user-face{\n    position:absolute;\n    top:17px;\n}\n\n.gradient-text {\n   color:  rgba(247, 100, 80, 1)\n}\n.gradient-text2 {\n   color: rgba(32, 165, 99, 1) \n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
